/** Namespace i18n du module partagé KPI U340x. */
export const NS = 'u340xKpi';
